import React from "react";

import Tabela from "../comum/Tabela";
import { dataHora, reais } from "../comum/formato";

export default function PedidosDaCampanha({ pedidos }) {
  const colunas = [
    { id: "codigo", rotulo: "Pedido", valor: (p) => p.codigo, render: (p) => <b>{p.codigo}</b> },
    { id: "quando", rotulo: "Quando", valor: (p) => p.criado_em, render: (p) => <span className="text-xs">{dataHora(p.criado_em)}</span> },
    { id: "cliente", rotulo: "Cliente", valor: (p) => p.cliente_nome || "", render: (p) => (
      <span>{p.cliente_nome || "—"}{p.cliente_novo && <span className="ml-1.5 text-[10px] font-bold uppercase text-emerald-600 dark:text-emerald-400">novo</span>}</span>) },
    { id: "anuncio", rotulo: "Anúncio", valor: (p) => p.anuncio || "", render: (p) => <span className="text-xs tabular-nums">{p.anuncio || "—"}</span> },
    { id: "tempo", rotulo: "Clique → pedido", alinhar: "direita", valor: (p) => p.minutos_apos_clique, render: (p) => (p.minutos_apos_clique == null ? "—" : p.minutos_apos_clique < 60 ? `${p.minutos_apos_clique} min` : `${Math.round(p.minutos_apos_clique / 60)} h`) },
    { id: "total", rotulo: "Total", alinhar: "direita", valor: (p) => p.total, render: (p) => <b>{reais(p.total)}</b> },
    { id: "lucro", rotulo: "Lucro", alinhar: "direita", valor: (p) => p.lucro, render: (p) => (p.lucro == null ? <span className="text-muted-foreground">—</span>
      : <span className={p.lucro < 0 ? "text-red-500" : "text-emerald-600 dark:text-emerald-400"}>{reais(p.lucro)}</span>) },
    { id: "situacao", rotulo: "Situação", render: (p) => (p.cancelado ? <span className="text-xs text-red-500 font-semibold">cancelado</span> : <span className="text-xs text-muted-foreground">{p.status}</span>) },
  ];
  return (
    <section className="rounded-xl border bg-card p-4 sm:p-5">
      <h3 className="font-semibold mb-2">Pedidos que vieram do anúncio</h3>
      <Tabela colunas={colunas} linhas={pedidos || []} ordemInicial={{ id: "quando", desc: true }} vazio="Nenhum pedido no período." e2e="tabela-pedidos-meta" chave={(p) => p.id} />
    </section>
  );
}
